/// <amd-module name="Search/Package/Flux/Stores/ZeroDataStore" />

import * as BaseZeroDataStore from "Search/Shared/Base/Stores/ZeroDataStore2";
import { IResultsLoadedPayload } from "Search/Shared/Base/ActionsHub2";
import { PackageSearchRequest, PackageSearchResponseContent, PackageResult } from "Search/WebApi/Contracts/Search.Shared";
import { areQueriesSame } from "Search/Package/Utils"

export class ZeroDataStore extends BaseZeroDataStore.ZeroDataStore {
    public onResultsLoaded(
        request: PackageSearchRequest,
        payload: IResultsLoadedPayload<PackageSearchRequest, PackageSearchResponseContent, PackageResult>,
        fetchMoreScenario: boolean): void {
        if (areQueriesSame(request, payload.request)) {
            const response = payload.response;
            if (response && response.results.length <= 0) {
                this._state.scenario = BaseZeroDataStore
                    .getScenario(payload.response.infoCode, response.results.length, fetchMoreScenario);
            }

            this.emitChanged();
        }
    }
}